module.exports = {
  android: "android",
  apple: "apple",
  huawei: "huawei",
  web: "web",
};
